import React, { Fragment } from 'react';
import { Intro, Dropdown } from 'dea-core';
import img from '../../assets/images/U1-T1-13.svg';

const options = [10, 75, '130+'];

const data = [
  {
    label: 'How many people die from an opioid overdose every day?',
    options
  }
];

const feedback = {
  // TODO do not let this feedback make it into the final version
  success: {
    title: 'Correct',
    body: ''
  },
  error: {
    title: 'Not quite!',
    body: 'Unfortunately the number is much higher.'
  },
  retry: {
    title: 'Not quite! Try again!',
    body: ''
  }
};

const correctInput = {
  [data[0].label]: '130+'
};

export default {
  title: 'Question 3',
  path: '/challenge/question-3',
  content: (
    <Fragment>
      <Intro
        title="Show What You Learned"
        direction="Select the best answers."
        img={img}
      />
      <Dropdown
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/evaluate/Question3.js